import React, { useEffect, useRef, useState } from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment, { now } from 'moment'
import 'moment-timezone'
import "react-big-calendar/lib/css/react-big-calendar.css";
import '../styles/ClickableCalendar.css'
import { useNavigate } from "react-router-dom";
import { EventFullInfo } from '../../../../models/event';
import { fetchCalendarEvents} from '../utils';

export interface ClickableCalendarProps {
  
}

export const ClickableCalendar:React.FC<ClickableCalendarProps> = (props) =>{

  const momNow = moment();
  const defaultStart = momNow.startOf('month').toDate();
  const defaultEnd = momNow.endOf('month').toDate();
  const [calRange, setCalRange] = useState<Date[]>([defaultStart, defaultEnd]);
  const [loadEvents, setLoadEvents] =useState<boolean>(true);
  const [eventsLoaded, setEventsLoaded] = useState<boolean>(false);
  const [events, setEvents] = useState<EventFullInfo[]>([]);

  const navigate = useNavigate();

  const handleEventClick =(e:any)=>{
    e?.id && navigate('/events/eventpage/' + e.id)
  }

  const handleIsLoading = () => {}

  const handleEventsLoaded = (events:EventFullInfo[]) => 
  {
    setEvents(events);
    setEventsLoaded(true);
  }

  const handleRangeChange = (range: Date[] | {start: Date, end: Date}) => {

    console.log( 'Range Change : ' + range.toString())

      if (Array.isArray(range))
      {
        range as Date[];
        const start_range = range[0];
        const end_range = range[range.length - 1];
        setCalRange([start_range, end_range]);
        setEventsLoaded(false);
        setLoadEvents(true);
      }
      else
      {
        range as {start: Date, end: Date};
        const start_range = range.start;
        const end_range = range.end;
        setCalRange([start_range, end_range]);
        setEventsLoaded(false);
        setLoadEvents(true);
      }
  }

  useEffect(() => 
  {
    if (loadEvents) 
    {
      fetchCalendarEvents(handleIsLoading, handleEventsLoaded, (err)=>console.error(err), calRange[0], calRange[calRange.length - 1]);
      setLoadEvents(false);
    }
  }, [loadEvents])

  // Set calendar timezone here
  moment.tz.setDefault('America/New_York');
  const localizer = momentLocalizer(moment);
  return (
    <div style={{height:'100%', width:'100%'}}>
      {!eventsLoaded && <p>Loading Events</p>}
      {<Calendar
        style={{height:'100%', width:'100%'}}
        localizer={localizer}
        onSelectEvent={(e) => handleEventClick(e)}
        onRangeChange={(e) => handleRangeChange(e)}
        events={events}
        startAccessor={(event) => event.start_DateTime}
        endAccessor={(event) => event.end_DateTime}
        titleAccessor={(event) => event.name}
      />}
    </div>
  )
}